<template>
   <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.6">
              <path
                d="M12 22.75C17.93 22.75 22.75 17.93 22.75 12C22.75 6.07 17.93 1.25 12 1.25C6.07 1.25 1.25 6.07 1.25 12C1.25 17.93 6.07 22.75 12 22.75ZM12 2.75C17.1 2.75 21.25 6.9 21.25 12C21.25 17.1 17.1 21.25 12 21.25C6.9 21.25 2.75 17.1 2.75 12C2.75 6.9 6.9 2.75 12 2.75Z"
                fill="#121722"
              />
              <path
                d="M14.8306 15.5794C15.0206 15.5794 15.2106 15.5094 15.3606 15.3594C15.6506 15.0694 15.6506 14.5894 15.3606 14.2994L9.70062 8.63938C9.41062 8.34938 8.93063 8.34938 8.64063 8.63938C8.35063 8.92937 8.35063 9.40937 8.64063 9.69937L14.3006 15.3594C14.4406 15.5094 14.6406 15.5794 14.8306 15.5794Z"
                fill="#121722"
              />
              <path
                d="M9.17063 15.5794C9.36063 15.5794 9.55062 15.5094 9.70062 15.3594L15.3606 9.69937C15.6506 9.40937 15.6506 8.92937 15.3606 8.63938C15.0706 8.34938 14.5906 8.34938 14.3006 8.63938L8.64063 14.2994C8.35063 14.5894 8.35063 15.0694 8.64063 15.3594C8.79063 15.5094 8.98063 15.5794 9.17063 15.5794Z"
                fill="#121722"
              />
            </g>
          </svg>
</template>